import { useScriptMode } from "../../../../contexts/ScriptModeContext";
import { soft } from "./softClasses";

const TR_MONTHS = [
  "Ocak",
  "Şubat",
  "Mart",
  "Nisan",
  "Mayıs",
  "Haziran",
  "Temmuz",
  "Ağustos",
  "Eylül",
  "Ekim",
  "Kasım",
  "Aralık",
];

function formatTrDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getDate()} ${TR_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

/**
 * Genel Bilgi: grubun künyesi satır satır (ad, açıklama, kuruluş, üye ve
 * yönetici sayısı, kurucu). Altta sabit bölge (ör. Grubu Sil) `footer` ile gelir.
 */
export default function GroupGeneralInfo({ group, founderName, footer }) {
  const { t } = useScriptMode();
  const rows = [
    { label: t("Grup adı"), value: group?.groupName },
    { label: t("Açıklama"), value: group?.description || t("Açıklama eklenmemiş.") },
    { label: t("Kuruluş"), value: formatTrDate(group?.createdAt) },
    { label: t("Üye"), value: String(group?.memberCount ?? (group?.members || []).length ?? 0) },
    {
      label: t("Yönetici"),
      value: String(group?.totalManagers ?? (group?.managers || []).length ?? 0),
    },
    founderName ? { label: t("Kurucu"), value: founderName } : null,
  ].filter((row) => row && row.value);

  return (
    <div className="flex flex-col h-full min-h-0">
      <dl className="flex-1 min-h-0 overflow-y-auto">
        {rows.map((row) => (
          <div key={row.label} className={`${soft.row} justify-between`}>
            <dt className={`text-sm ${soft.muted}`}>{row.label}</dt>
            <dd className={`text-sm font-medium text-right max-w-[65%] ${soft.ink}`}>{row.value}</dd>
          </div>
        ))}
      </dl>
      {footer ? (
        <div className="shrink-0 px-5 py-3 border-t border-terakkiBorder dark:border-white/15">{footer}</div>
      ) : null}
    </div>
  );
}
